import { Message } from 'element-ui';

//阻止默认行为
export function prevent(event){
  var e = event || window.event;
  if (typeof e.preventDefault !== 'undefined'){ //W3C
    e.preventDefault();
  } else {  //IE
    e.returnValue = false;
  }
}
//阻止冒泡
export function stopPro(event) {
  var e = event || window.event;

  if (typeof e.stopPropagation !== 'undefined') {
    e.stopPropagation();
  } else {
    e.cancelBubble = true;
  }

  e.nativeEvent.stopImmediatePropagation();
}

// 删除首尾空格
export function trim(str){
  if ([undefined, null, NaN, ''].includes(str)){
    return '';
  } else{
    let toStr = str.toString();
    return toStr.replace(/(^\s*)|(\s*$)/g,'');
  }
}
// 是否是json字符串
export function isJSON(str){
  if (typeof str === 'string'){
    try {
      let obj = JSON.parse(str);
      if (obj && getType(obj) === 'object') return true;
      return false;
    } catch(e){
      return false;
    }
  }
  return false;
}

export function getType(data) {
  const temp = Object.prototype.toString.call(data);
  // const type = temp.match(/^\[object\s(\w+)\]$/)[1];
  const type = temp.slice(8, -1);
  return type.toLowerCase();
}

export function promisify(fn){
  return (...args) => {
    return new Promise((resolve, reject) => {
      fn(...args, (err, data) => {
        if (err) reject(err);
        resolve(data);
      })
    })
  }
}


/**
 * @param {*} fn 函数
 * @param {*} delay 延迟时间，单位 ms
 * @param {*} immediate 是否立即执行，默认为false
 * @param {*} context 上下文
 *
 */
 export function debounce(
  fn,
  delay=300,
  immediate,
  context
) {
  let timer = null;

  return function (...args) {
    context = context || this;

    if (timer) {
      clearTimeout(timer);
    } else {
      if (immediate) fn.apply(context, args);
    }
    timer = setTimeout(() => {
      immediate ? (timer = null) : fn.apply(context, args);
    }, delay);
  };
}

/**
 * @param {*} fn 函数
 * @param {*} delay 延迟时间，单位 ms
 * @param {*} immediate 是否立即执行，默认为false
 * @param {*} context 上下文
 *
 */
export function throttle(
  fn,
  delay=300,
  immediate,
  context
){
  let timer = null;

  return function (...args) {
    context = context || this;
    if (!timer) {
      immediate && fn.apply(context, args);
      timer = setTimeout(() => {
        timer = null;
        !immediate && fn.apply(context, args);
      }, delay);
    }
  };
}


// 获取类型
const TYPE_OBJECT = [
  {},
  [],
  new Map(),
  new Set(),
  new Error(),
  new Date(),
  /^$/,
].map((item) => getType(item));
const TYPE_MAP = getType(new Map());
const TYPE_SET = getType(new Set());
const TYPE_SYMBOL = getType(Symbol("1"));
const TYPE_REGEXP = getType(/^$/);
const TYPE_CONSTRUCTOR = [new Error(), new Date()].map((item) => getType(item));

// 深拷贝
export function copy(source, map = new Map()) {
  const type = getType(source);

  // 基本数据类型，直接返回
  if (!TYPE_OBJECT.includes(type)) return source;

  // 如果值是对象自身
  // map key是原对象的内存地址；value是克隆后的对象的内存地址
  if (map.get(source)) return map.get(source);

  // 基于老的 oldDate 创建一个新的实例
  if (TYPE_CONSTRUCTOR.includes(type)) return new source.constructor(source);

  // 创建一个新的实例
  let target = new source.constructor(); //{} []
  map.set(source, source);

  // 克隆 Symbol
  if (TYPE_SYMBOL === type)
    return Object(Symbol.prototype.valueOf.call(source));

  // 克隆正则
  if (TYPE_REGEXP === type) {
    const flags = /\w*$/;
    const target = new RegExp(source.source, flags.exec(source));
    target.lastIndex = source.lastIndex; //清空正则匹配索引
    return target;
  }

  // 克隆 set
  if (TYPE_SET === type) {
    source.forEach((value) => target.add(copy(value, map)));
    return target;
  }

  // 克隆 map
  if (TYPE_MAP === type) {
    source.forEach((value, key) => target.set(key, copy(value, map)));
    return target;
  }

  // 克隆普通对象和数组
  let keys = Object.keys(source);
  let length = keys.length;
  let index = 0;

  while (index < length) {
    let key = keys[index];
    target[key] = copy(source[key], map);
    index++;
  }

  return target;
}

// 不补零数字排序
// const arr = [10, 2, 3456789];
// function ()
// arr.sort((a, b) => {
//   const lenA = String(a).length; // a 的位数
//   const lenB = String(b).length; // b 的位数
  
//   if (lenA === lenB) {
//     return a - b; // 相同位数时按照数值大小排序
//   } else {
//     return lenA - lenB; // 根据位数排序
//   }
// });
// console.log(arr); // 输出结果：[2, 10, 3456789]


// 复制文本
export function copyText(text) {
  if (window !== window.top){ //iframe中时，选用已弃用方法
    fake();
  } else {  //其它采用剪切板API
    if (navigator.clipboard) {
      // clipboard api 复制
      navigator.clipboard.writeText(text);
      Message.success('复制成功！');
    } else if (window.clipboardData) {
      //如果是IE浏览器
      // 在ie中window.clipboardData（剪切板对象）是可以被获取
      window.clipboardData.setData('text', text);
    } else {
      fake();
    }
  }

  function fake(){
    const textarea = document.createElement('textarea');
    document.body.appendChild(textarea);
    // 隐藏此输入框
    textarea.style.position = 'fixed';
    textarea.style.clip = 'rect(0 0 0 0)';
    textarea.style.top = '10px';
    // 赋值
    textarea.value = text;
    // 选中
    textarea.select(); //选中所有
    // oIpt.setSelectionRange(0, 2);	//选中前2个字符
    // 复制
    document.execCommand('copy', true);
    // 移除输入框
    document.body.removeChild(textarea);
  }
}

// 小驼峰、大驼峰 转换 连字符
export function toLowerLine(str, sep='-') {
  if (typeof str !== 'string') throw new Error('argument is not a string');
  let result = str.replace(/([A-Z])/g, `${sep}$1`).toLowerCase();
  if (result.charAt() === sep) result = result.slice(1);
  return result;
}
// 连字符 转换 小驼峰、大驼峰
export function toCamelCase(str, isBig) {
  if (typeof str !== 'string') throw new Error('argument is not a string');
  const reg = /([^-])(?:-+([^-]))/g;
  let result = str.replace(reg, (_, $1, $2) => {
    return $1 + $2.toUpperCase();
  });
  if (isBig){
    const firstLetter = result.charAt();
    if (/[A-z]/.test(firstLetter)) result = firstLetter.toUpperCase() + result.slice(1);
  }
  return result;
}

// style 对象转字符串拼接
export function getStyleStr(style) {
  return Object.keys(style)
    .map((key) => `${toLowerLine(key)}: ${style[key]};`)
    .join(' ');
}

// 获得区间内 随机数字 [min, max]
export function getRandomNumber(min, max){
  return Math.floor(Math.random() * (max - min + 1) + min);
}

// 获取随机字符串
export function getRandomString(len=10){
  // Math.random().toString(32) 最大为11位
  // 26个小写字母 + 10个数字
  return len < 11
    ? Math.random().toString(32).slice(2, 2 + len).padEnd(len, '0')
    : getRandomString(11) + getRandomString(len - 11);
}

// 数字千分位
export function formatNumberThousandth(num){
  if (!['string', 'number'].includes(typeof num)) return '';
  if (['', NaN].includes(num)) return '';

  num = num.toString();
  if (num.includes('.')){
    return num.replace(/(\d)(?=(\d{3})+\.)/g, "$1,");
  }
  return num.replace(/(\d)(?=(\d{3})+$)/g, "$1,");
}

// 解析json
export function parseJSON(jsonString) {
  try {
    const result = JSON.parse(jsonString);
    if (['', 'null', 'undefined', null, undefined].includes(result)) return;
    return result;
  } catch (error) {
    console.error("解析JSON时发生错误:", error);
    return; // 或者其他合适的错误处理
  }
}

//转义(元素的innerHTML内容即为转义后的字符) 
export function htmlEncode ( str ) {  
  const ele = document.createElement('span');  
  ele.appendChild( document.createTextNode( str ) );
  return ele.innerHTML;  
}  
//转义解析   
export function htmlDecode ( str ) {  
  const ele = document.createElement('span');  
  ele.innerHTML = str;  
  return ele.textContent;  
}  
